import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/App.css';
import FAQ from '../components/FAQ/FAQ';
import Gallery from '../components/Gallery/Gallery';
import Help from '../components/Help/Help';
import { DOWNLOAD_LINKS, getDownloadLink, detectPlatform } from '../config/downloadLinks';
import logo from '../assets/images/phonemousewhite.svg';

const title = 'AirMouse';

export default function Home() {
  const downloadRef = useRef(null);
  const imagesRef = useRef(null);
  const helpRef = useRef(null);
  const FAQRef = useRef(null);
  const [platform, setPlatform] = useState('windows');
  const [showDropdown, setShowDropdown] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const userPlatform = detectPlatform();
    setPlatform(userPlatform);
  }, []);

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const map = {
        download: downloadRef,
        gallery: imagesRef,
        help: helpRef,
        faq: FAQRef,
      };
      const ref = map[location.state.scrollTo];
      if (ref && ref.current) {
        const navbarHeight = 80;
        const elementPosition = ref.current.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }
    }
  }, [location.state]);

  const handlePlatformChange = (newPlatform) => {
    setPlatform(newPlatform);
    setShowDropdown(false);
  };

  // iOS button now links directly to App Store via anchor href

  return (
    <>
      <header ref={downloadRef} className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <header className="App-titletext">
          {title}
        </header>
      </header>
      <div className="download-buttons">
        <div className="ios-download-container">
          <a href={DOWNLOAD_LINKS.APP_STORE} className="ios-download-button">
            <svg className="apple-icon" viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            <span>Download iOS</span>
          </a>
        </div>
        <div className="server-download-container desktop-only">
          <a href={getDownloadLink(platform)} className="windows-download-button">
            <div className="button-main" onClick={(e) => {
              e.preventDefault();
              window.location.href = getDownloadLink(platform);
            }}>
              <svg className="download-icon" viewBox="0 0 24 24" width="24" height="24">
                <path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
              </svg>
              <span>Download for<br/>{platform === 'windows' ? 'Windows' : 'macOS'}</span>
            </div>
            <div className="button-dropdown" onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowDropdown(!showDropdown);
            }}>
              <svg className="dropdown-arrow" viewBox="0 0 24 24" width="24" height="24">
                <path fill="currentColor" d="M7 10l5 5 5-5z"/>
              </svg>
            </div>
          </a>
          {showDropdown && (
            <div className="platform-dropdown">
              <button onClick={() => handlePlatformChange('windows')}>Windows</button>
              <button onClick={() => handlePlatformChange('macos')}>macOS</button>
            </div>
          )}
        </div>
      </div>

      <div ref={imagesRef} className="image-container-main desktop-only">
        <Gallery/>
      </div>

      <div ref={helpRef} className="help-container-main">
        <Help />
      </div>

      <div ref={FAQRef} className="FAQ-container-main">
        <FAQ />
      </div>

      <div className="support-container">
        <div className="support-content">
          <h2>Need More Help?</h2>
          <p>If you have additional questions or need further assistance, our support team is here to help.</p>
          <div className="support-email">
            <span className="email-label">Contact us at:</span>
            <a href="mailto:airmouse.help@gmail.com" className="support-email-link">
              airmouse.help@gmail.com
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

